import { render, staticRenderFns } from "./RepetitiveChecksTanker.vue?vue&type=template&id=0c1074c8&scoped=true&"
import script from "./RepetitiveChecksTanker.vue?vue&type=script&lang=js&"
export * from "./RepetitiveChecksTanker.vue?vue&type=script&lang=js&"
import style0 from "./RepetitiveChecksTanker.vue?vue&type=style&index=0&id=0c1074c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1074c8",
  null
  
)

export default component.exports